import { queryClient } from '@/react-query/react-query-instance';
import { EdgeData, NodeDataMini } from '@/services/twttr-graph-service';
import { traceError } from '@/utils/trace-error';
import { Route } from './+types/route';
import { edgesQueryOptions } from './edges-query';

const emptyEdgeData: EdgeData[] = [];

export const graphClientLoader = async ({
  request,
}: Route.ClientLoaderArgs) => {
  const searchParams = new URL(request.url).searchParams;
  const node = searchParams.get('node');
  const edgeDirection = searchParams.get('dir') === 'out' ? 'out' : 'in';

  const nodesPromise = queryClient.ensureQueryData<NodeDataMini[]>({
    queryKey: ['nodes'],
    staleTime: Infinity,
    queryFn: () =>
      fetch('/static/nodes_mini_v1.json').then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load nodes');
        }
        return res.json();
      }),
  });

  const edgesPromise = node
    ? queryClient
        .ensureQueryData(edgesQueryOptions(node, edgeDirection))
        .catch((err) => {
          // TODO: show toast
          traceError(
            new Error(
              'Failed to load ' + edgeDirection + ' edges for node ' + node,
              {
                cause: err,
              },
            ),
          );
          return emptyEdgeData;
        })
    : emptyEdgeData;

  const [nodes, edges] = await Promise.all([nodesPromise, edgesPromise]);

  return {
    nodes,
    edges: edges as EdgeData[],
  };
};
graphClientLoader.hydrate = true;
